import { InputViewTestIdFactory } from '../../components/InputView/interactions';
export const NumberInputTestIdFactory = {
    // bases, can be used for regex matching in playwright getbytestid
    getNumberInputBase: () => 'number',
    // testid generators
    getNumberInputLabelTestId: (testId) => InputViewTestIdFactory.getInputViewLabelTestId(NumberInputTestIdFactory.getNumberInputBase(), testId),
    getNumberInputDescriptionTestId: (testId) => InputViewTestIdFactory.getInputViewDescriptionTestId(NumberInputTestIdFactory.getNumberInputBase(), testId),
    getNumberInputInputTestId: (testId) => [
        InputViewTestIdFactory.getInputViewInputTestId(NumberInputTestIdFactory.getNumberInputBase(), testId),
    ].join('-'),
};
